import type { ReactNode } from 'react'
import styles from './SidebarLayout.module.css'

export interface SidebarLayoutProps {
  /**
   * What can be selected, like a `SidebarMenu`.
   */
  sidebar: ReactNode
  /**
   * The selected item: an `EditorPage`, optionally followed by an
   * `Inspector`.
   */
  children?: ReactNode
  testId?: string
}

/**
 * A tab with a sidebar to pick from along the left, and what was picked
 * next to it.
 *
 * Not `SplitView`: its side pane is a 400px collapsible list pane, while
 * the editor needs a narrow, fixed menu column that leaves room for an
 * inspector.
 */
export function SidebarLayout({
  sidebar,
  children,
  testId,
}: SidebarLayoutProps) {
  return (
    <div className={styles.root} data-test={testId}>
      {sidebar}
      <div className={styles.page}>{children}</div>
    </div>
  )
}
